import React from "react";
import { View, Text } from "react-native";

export default function CalendarScreen(): JSX.Element {
  return (
    <View>
      <Text>Calendar</Text>
      <View />
    </View>
  );
}
